import { SelectOption } from '@shared/components/select';

export const getSelectOptionsFromEnum = (enumObj: object): SelectOption[] => {
  return Object.entries(enumObj).map(([key, value]) => ({
    label: key,
    value: value,
  }));
};
